import React from 'react'

const Footer = () => {
  return (
    <div>
      {/* <h1>footer</h1> */}
    </div>
  )
}

export default Footer
